import { Breadcrumb } from '../../interfaces/breadcrumb'
import BreadcrumbAction from '../actions/BreadcrumbAction'

type State = {
  breadcrumbs: Breadcrumb[]
}

class BreadcrumbTrailReducer {

  static initialState: State = {
    breadcrumbs: []
  }

  static reducer = (state = BreadcrumbTrailReducer.initialState, action: { type: any; payload: { breadcrumbs: any } }) => {
    switch (action.type) {
      case BreadcrumbAction.UPDATE_BREADCRUMB_TRAIL:
        return {
          ...state,
          breadcrumbs: action.payload.breadcrumbs
        }
    }
    return state
  }
}

export default BreadcrumbTrailReducer